<script>
	import { onMount } from 'svelte';
	import i18n from './services/i18n.js'
	import { _, locale, locales } from 'svelte-i18n'
	import Clipboard, { callReloadClipboard, callDelItemClipboard } from './Clipboard.svelte'
	import { username, basicAuth, bearerToken, keepLogin } from './services/stores.js'
	import AddItem, { callAddItemClipboard } from './AddItem.svelte'
  import { NotificationDisplay, notifier } from '@beyonk/svelte-notifications'
	import Settings, { callToggleSettings } from './Settings.svelte'
	import { getJwt, refreshJwt, setApiBaseUrl } from './lib/pastyclient.lib.js'
	import { jwtDecode } from "jwt-decode";
	import Tos, { callToggleTos } from './Tos.svelte'
	import Error from './Error.svelte'
	import {
		Button,
		Form,
		FormGroup,
		FormText,
		Input,
		Label,
		Container,
		Row,
		Col,
		Collapse,
		Navbar,
		NavbarToggler,
		NavbarBrand,
		Nav,
		NavItem,
		NavLink,
		Dropdown,
		DropdownToggle,
		DropdownMenu,
		DropdownItem
 	} from '@sveltestrap/sveltestrap'

	let loggedIn = false
	let isOpen = false
	let dropdownOpen = false;
	let password = ''
	let keepLoginChecked = false


	let apiUrl = process.env.API_URL || 'http://localhost:3000';

	if (apiUrl === undefined) apiUrl = 'https://api.pastyapp.org/v3'
	console.log("UFTU ${apiUrl}")
	setApiBaseUrl(apiUrl)

	onMount(async () => {
		// read localStorage variables
		if (localStorage.getItem('locale') !== null) $locale = localStorage.getItem('locale')
		if (localStorage.getItem('keepLogin') !== null) $keepLogin = JSON.parse(localStorage.getItem('keepLogin'))

		// set up store to localStorage sync
	 	locale.subscribe(value => {
	  	localStorage.setItem('locale', value);
	 	})

	 	keepLogin.subscribe(value => {
	  	localStorage.setItem('keepLogin', JSON.stringify(value));
	 	})

		if ($keepLogin) {
			await tryTokenRefresh()
		} else {
			localStorage.removeItem('username')
			localStorage.removeItem('refreshToken')
		}
  })

	const tryTokenRefresh = async () => {
		// see if we have a valid refreshToken
		const refreshToken = localStorage.getItem('refreshToken')
		if (refreshToken !== null) {
			if (localStorage.getItem('username') !== null) $username = localStorage.getItem('username')
			try {
				const accessToken = await refreshJwt(refreshToken, $username)
				if (accessToken !== undefined) {
					$bearerToken = accessToken
					loggedIn = true
					return true
				}
			} catch(err) {
				// could not refresh JWT token
				logout()
				return false
			}
		}
	}

	const handleDispatchItemAdded = () => {
		callReloadClipboard()
	}

	const handleDispatchLoginFailed = (event) => {
		if ($keepLogin) {
			tryTokenRefresh().then(success => {
				if (success) {
					if (event.detail) {
						switch(event.detail.failed) {
							case 'clipboardList':
								callReloadClipboard()
								break
							case 'clipboardAdd':
								callAddItemClipboard(event.detail.item)
								break
							case 'clipboardDel':
								callDelItemClipboard(event.detail.itemId)
								break
						}
					}
				}
			})
		} else {
			throw new Error($_('error.login_failed'))
		}
	}

	const handleCollapseUpdate = (event) => {
		isOpen = event.detail.isOpen
	}

	const setLocale = (loc => {
		$locale = loc
	})

	const login = () => {
		getJwt({ username: $username, password }).then(res => {
			$bearerToken = res
			loggedIn = true
			if($keepLogin) {
				// store refresh token
				const decodedToken = jwtDecode($bearerToken.accessToken)
				if (decodedToken.refreshToken !== undefined) {
					localStorage.setItem('refreshToken', decodedToken.refreshToken)
					localStorage.setItem('username', $username)
				}

			}
		}).catch(err => {
			loggedIn = false
			if (err.message === 'Invalid login credentials') {
				err.message = $_('error.login_failed')
			}
			notifier.danger(err.message, { timeout: 5000 })
		})
	}

	const logout = () => {
		$basicAuth = undefined
		$bearerToken = undefined
		loggedIn = false
		notifier.danger($_('notif.logged_out'), { timeout: 5000 })
	}

	const handleLogoutClick = () => {
		$keepLogin = false
		$username = undefined
		password = undefined
		localStorage.removeItem('username')
		localStorage.removeItem('refreshToken')
		logout()
	}

	const handleClipboardClick = () => {
		callReloadClipboard()
	}

	const toggleSetting = () => {
		callToggleSettings()
	}

	const toggleTos = () => {
		callToggleTos()
	}
	const cancelSubmit = (e) => {
		e.preventDefault()
	}

</script>

<Navbar color="dark" dark expand="md">
	<NavbarBrand href="/">{$_('app_name')}</NavbarBrand>
	<NavbarToggler on:click={() => (isOpen = !isOpen)} />
	<Collapse {isOpen} navbar expand="md" on:update={handleCollapseUpdate}>
		<Nav class="ml-auto" navbar>
			{#if loggedIn}
				<NavItem>
					<NavLink on:click={handleClipboardClick}>{$_('nav.clipboard')}</NavLink>
				</NavItem>
			{/if}
			<NavItem>
				<NavLink href="https://pastyapp.org">{$_('nav.about')}</NavLink>
			</NavItem>
			{#if loggedIn}
				<NavItem>
					<NavLink href="#settings/" on:click={toggleSetting}>{$_('nav.settings')}</NavLink>
				</NavItem>
			{/if}
      <Dropdown nav inNavbar isOpen={dropdownOpen} toggle={() => dropdownOpen = !dropdownOpen}>
        <DropdownToggle nav caret>{$_('locale.locale')}</DropdownToggle>
        <DropdownMenu right>
					{#each $locales as locale}
          	<DropdownItem on:click={setLocale(locale)}>{$_('locale.' + locale)}</DropdownItem>
					{/each}
        </DropdownMenu>
      </Dropdown>
			{#if loggedIn}
				<NavItem>
					<NavLink href="#logout/" on:click={handleLogoutClick}>{$_('nav.logout')}</NavLink>
				</NavItem>
			{/if}
    </Nav>
  </Collapse>
</Navbar>
<Error/>
<Container class="mt-4">
	<Row>
		<Col class="col-12">
			<NotificationDisplay/>
		</Col>
	</Row>
	<Row>
		<Col class="col-auto ml-4 mr-0 pr-0" style="min-width: 140px">
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<img alt="One Happy Cloud" src='Pasty_nocloud.png' on:click={handleClipboardClick} />
		</Col>
		<Col class="col-md-9 col-sm-10 col-12">
			<Container class="ml-4 my-4">
				<Row>
					<h2>
						{$_('page_title')}{#if loggedIn}, {$username}{/if}
					</h2>
				</Row>
				<Row>
					{$_('page_subtitle')}
				</Row>
			</Container>
		</Col>
	</Row>
	<Row>
		{#if loggedIn}
			<Col class="col-lg-9">
				<Clipboard on:login_failed={handleDispatchLoginFailed} />
			</Col>
			<Col class="col-lg-3">
				<AddItem on:item_added={handleDispatchItemAdded} on:login_failed={handleDispatchLoginFailed}/>
			</Col>
			<Settings />
		{:else}
			<Col class="col-md-5 col-sm-6 col-lg-4">
				<Container class="ml-2 mt-4"><b>{$_('login.str')}</b></Container>
				<Form class="ml-3 mt-1" on:submit={cancelSubmit}>
					<FormGroup>
						<Input class="m-1" bind:value={$username} placeholder="{$_('login.placeholder.username')}" />
						<Input class="m-1" type="password" bind:value={password} placeholder="{$_('login.placeholder.password')}" />
						<Button class="m-1" color="primary" on:click={login}>
							{$_('login.button')}
						</Button>
						<Label class="m-1 ml-4" check>
							<Input id="keepLoginCheckbox" type="checkbox" bind:checked={$keepLogin}/>{$_('login.keep')}
						</Label>
					</FormGroup>
				</Form>
			</Col>
		{/if}
	</Row>
</Container>
<Navbar class="mt-5" color="light" light expand="md">
	<Nav class="ml-auto" navbar>
		<NavItem>
			<NavLink on:click={toggleTos}>{$_('footer.terms_of_service')}</NavLink>
		</NavItem>
		<NavItem>
			<NavLink href="https://www.electricdynamite.de/privacy.html">{$_('footer.privacy_policy')}</NavLink>
		</NavItem>
	</Nav>
</Navbar>
<Tos />
